import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { Button, Input, RadioButton, Select, AddAlert } from '../../../../components'
import './canalferramenta.scss'

const obterConfiguracaoFerramenta = ferramentaCodigo => {
  switch (ferramentaCodigo) {
    case 'asana':
      return {
        codigo: 'asana',
        exibirCampoUrl: true,
        exibirNomeDestino: true,
        exibirIssueTypeSelect: false,
        labelNome: 'projectNameLabel',
        labelBotaoValidar: 'save',
        labelBotaoBuscar: 'validate',
        labelBotaoBuscarConfiguracao: 'search'
      }

    case 'clickup':
      return {
        codigo: 'clickup',
        exibirCampoUrl: true,
        exibirNomeDestino: true,
        exibirIssueTypeSelect: false,
        labelNome: 'listNameLabel',
        labelBotaoValidar: 'save',
        labelBotaoBuscar: 'validate',
        labelBotaoBuscarConfiguracao: 'search'
      }

    case 'trello':
      return {
        codigo: 'trello',
        exibirCampoUrl: true,
        exibirNomeDestino: true,
        exibirListaSelect: true,
        exibirIssueTypeSelect: false,
        labelNome: 'boardNameLabel',
        labelLista: 'listNameLabel',
        labelBotaoValidar: 'save',
        labelBotaoBuscar: 'validate',
        labelBotaoBuscarConfiguracao: 'search'
      }


    case 'jira':
      return {
        codigo: 'jira',
        exibirCampoUrl: true,
        exibirNomeDestino: true,
        exibirIssueTypeSelect: true,
        labelNome: 'projectNameLabel',
        labelBotaoValidar: 'jiraValidateButtonLabel',
        labelBotaoBuscar: 'jiraSearchIssueTypesButtonLabel',
        labelBotaoBuscarConfiguracao: 'jiraSearchConfigurationButtonLabel'
      }

    case 'monday':
      return {
        codigo: 'monday',
        exibirCampoUrl: true,
        exibirNomeDestino: true,
        exibirListaSelect: true,
        exibirIssueTypeSelect: false,
        labelNome: 'boardNameLabel',
        labelLista: 'groupNameLabel',
        labelBotaoValidar: 'mondayValidateButtonLabel',
        labelBotaoBuscar: 'mondaySearchGroupsButtonLabel',
        labelBotaoBuscarConfiguracao: 'mondaySearchConfigurationButtonLabel'
      }



    default:
      return null
  }
}

const extrairDestinoSalvo = ({ ferramentaCodigo, destinoSalvo }) => {
  const destino = destinoSalvo?.destino || null

  switch (ferramentaCodigo) {
    case 'asana':
      return {
        urlProjeto: destino?.urlDestino || destino?.destinoUrl || '',
        projetoExternoId: destino?.projectId || null,
        listExternoId: null,
        nomeDestino: destino?.projectName || '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: !!destino
      }

    case 'clickup':
      return {
        urlProjeto: destino?.urlDestino || destino?.destinoUrl || '',
        projetoExternoId: destino?.listId || null,
        listExternoId: null,
        nomeDestino: destino?.listName || '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: !!destino
      }


    case 'trello': {
      const listaOption = destino?.listId
        ? {
            label: destino?.listName || '',
            value: destino?.listId
          }
        : null

      return {
        urlProjeto: destino?.urlDestino || destino?.destinoUrl || '',
        projetoExternoId: destino?.boardId || null,
        listExternoId: destino?.listId || null,
        nomeDestino: destino?.boardName || '',
        listOptions: listaOption ? [listaOption] : [],
        listaSelecionada: listaOption || {},
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: !!destino
      }
    }



    case 'jira': {
      const issueTypeOption = destino?.issueTypeId
        ? {
            label: destino?.issueTypeName || '',
            value: destino?.issueTypeId
          }
        : null

      return {
        urlProjeto: destino?.urlDestino || destino?.destinoUrl || '',
        projetoExternoId: destino?.projectId || null,
        listExternoId: null,
        nomeDestino: destino?.projectName || '',
        issueTypeId: destino?.issueTypeId || null,
        issueTypeOptions: issueTypeOption ? [issueTypeOption] : [],
        issueTypeSelecionado: issueTypeOption || {},
        configuracaoConfirmada: !!destino
      }
    }


    case 'monday': {
      const grupoOption = destino?.groupId
        ? {
            label: destino?.groupName || '',
            value: destino?.groupId
          }
        : null

      return {
        urlProjeto: destino?.urlDestino || destino?.destinoUrl || '',
        projetoExternoId: destino?.boardId || null,
        listExternoId: destino?.groupId || null,
        nomeDestino: destino?.boardName || '',
        listOptions: grupoOption ? [grupoOption] : [],
        listaSelecionada: grupoOption || {},
        peopleColumnId: destino?.peopleColumnId || null,
        dateColumnId: destino?.dateColumnId || null,
        textNotasColumnId: destino?.textNotasColumnId || null,
        colunasValidas: !!destino,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: !!destino
      }
    }




    default:
      return {
        urlProjeto: '',
        projetoExternoId: null,
        listExternoId: null,
        nomeDestino: '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      }
  }
}

const extrairUrlValidada = ({ ferramentaCodigo, urlValidada }) => {
  switch (ferramentaCodigo) {
    case 'asana':
      return {
        projetoExternoId: urlValidada?.projectId || null,
        listExternoId: null,
        nomeDestino: urlValidada?.projectName || '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: true
      }

    case 'clickup':
      return {
        projetoExternoId: urlValidada?.listId || null,
        listExternoId: null,
        nomeDestino: urlValidada?.listName || '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: true
      }


    case 'trello': {
      const listas = Array.isArray(urlValidada?.listas) ? urlValidada.listas : []

      const listOptions = listas.map(item => ({
        label: item?.listName || '',
        value: item?.listId
      }))

      const listaSelecionada = listOptions[0] || {}

      return {
        projetoExternoId: urlValidada?.boardId || null,
        listExternoId: listaSelecionada?.value || null,
        nomeDestino: urlValidada?.boardName || '',
        listOptions,
        listaSelecionada,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: true
      }
    }



    case 'jira': {
      const issueTypes = Array.isArray(urlValidada?.issueTypes) ? urlValidada.issueTypes : []

      const issueTypeOptions = issueTypes
        .filter(item => item?.isSubtask !== true)
        .map(item => ({
          label: item?.issueTypeName || '',
          value: item?.issueTypeId
        }))

      const issueTypeSelecionado = issueTypeOptions[0] || {}

      return {
        projetoExternoId: urlValidada?.projectId || null,
        listExternoId: null,
        nomeDestino: urlValidada?.projectName || '',
        issueTypeId: issueTypeSelecionado?.value || null,
        issueTypeOptions,
        issueTypeSelecionado,
        configuracaoConfirmada: false
      }
    }

    case 'monday': {
      const grupos = Array.isArray(urlValidada?.grupos) ? urlValidada.grupos : []
      const colunas = Array.isArray(urlValidada?.colunas) ? urlValidada.colunas : []

      const groupOptions = grupos.map(item => ({
        label: item?.groupName || '',
        value: item?.groupId
      }))

      const grupoSelecionado = groupOptions[0] || {}

      const peopleColumn = colunas.find(item =>
        item?.columnType === 'people' && item?.columnTitle === 'RespYT'
      )

      const dateColumn = colunas.find(item =>
        item?.columnType === 'date' && item?.columnTitle === 'DateYT'
      )

      const textColumn = colunas.find(item =>
        item?.columnType === 'text' && item?.columnTitle === 'NoteYT'
      )

      const colunasValidas = !!peopleColumn && !!dateColumn && !!textColumn

      return {
        projetoExternoId: urlValidada?.boardId || null,
        listExternoId: grupoSelecionado?.value || null,
        nomeDestino: urlValidada?.boardName || '',
        listOptions: groupOptions,
        listaSelecionada: grupoSelecionado,
        peopleColumnId: peopleColumn?.columnId || null,
        dateColumnId: dateColumn?.columnId || null,
        textNotasColumnId: textColumn?.columnId || null,
        colunasValidas,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      }
    }


    default:
      return {
        projetoExternoId: null,
        listExternoId: null,
        nomeDestino: '',
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      }
  }
}

const Canalferramenta = ({
  integracao,
  destinoSalvo,
  urlValidada,
  loadingIntegracao,
  loadingBuscarDestino,
  loadingValidarUrl,
  loadingGravarDestino,
  nls,
  value,
  onChange,
  onBuscarDestino,
  onValidarUrl,
  onGravarDestino
}) => {
  const dispatch = useDispatch()
  const existeIntegracao = integracao?.existeIntegracao === true
  const ferramentaCodigo = integracao?.ferramentaCodigo || ''
  const ferramentaNomeExibicao = integracao?.ferramentaNomeExibicao || ''
  const ferramentaGestaoId = integracao?.ferramentaGestaoId || null

  const configuracaoFerramenta = useMemo(
    () => obterConfiguracaoFerramenta(ferramentaCodigo),
    [ferramentaCodigo]
  )

  const canalSelecionado = value?.canal || 'email'
  const urlProjeto = value?.urlProjeto || ''
  const nomeDestinoExibicao = value?.nomeDestino || ''

  const canalOptions = useMemo(() => ([
    { value: 'email', label: nls.channelEmailOption },
    { value: 'ferramenta', label: nls.channelToolOption }
  ]), [nls.channelEmailOption, nls.channelToolOption])

  useEffect(() => {
    if (!configuracaoFerramenta || !urlValidada) {
      return
    }

    const dadosValidados = extrairUrlValidada({
      ferramentaCodigo,
      urlValidada
    })

    if (ferramentaCodigo === 'jira' && value?.configuracaoConfirmada) {
      return
    }

    if (
      ferramentaCodigo === 'jira' &&
      Array.isArray(value?.issueTypeOptions) &&
      value.issueTypeOptions.length > 0 &&
      Array.isArray(dadosValidados?.issueTypeOptions) &&
      dadosValidados.issueTypeOptions.length === value.issueTypeOptions.length
    ) {
      return
    }

    if (
      ferramentaCodigo === 'trello' &&
      Array.isArray(value?.listOptions) &&
      value.listOptions.length > 0 &&
      Array.isArray(dadosValidados?.listOptions) &&
      dadosValidados.listOptions.length > 0
    ) {
      return
    }

    if (
      ferramentaCodigo === 'monday' &&
      Array.isArray(value?.listOptions) &&
      value.listOptions.length > 0 &&
      Array.isArray(dadosValidados?.listOptions) &&
      dadosValidados.listOptions.length > 0
    ) {
      return
    }


    if (dadosValidados?.projetoExternoId) {
      onChange({
        ...value,
        urlValidada: ferramentaCodigo === 'monday'
          ? !!dadosValidados.configuracaoConfirmada
          : true,
        projetoExternoId: dadosValidados.projetoExternoId,
        listExternoId: dadosValidados.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosValidados.nomeDestino,
        listOptions: dadosValidados.listOptions || [],
        listaSelecionada: dadosValidados.listaSelecionada || {},
        peopleColumnId: dadosValidados.peopleColumnId || null,
        dateColumnId: dadosValidados.dateColumnId || null,
        textNotasColumnId: dadosValidados.textNotasColumnId || null,
        colunasValidas: dadosValidados.colunasValidas || false,
        issueTypeId: dadosValidados.issueTypeId || null,
        issueTypeOptions: dadosValidados.issueTypeOptions || [],
        issueTypeSelecionado: dadosValidados.issueTypeSelecionado || {},
        configuracaoConfirmada: dadosValidados.configuracaoConfirmada || false
      })
    }
  }, [
    configuracaoFerramenta,
    ferramentaCodigo,
    ferramentaGestaoId,
    urlValidada,
    value,
    onChange
  ])

  const limparEstadoFerramenta = canal => ({
    ...value,
    canal,
    urlProjeto: '',
    urlValidada: false,
    projetoExternoId: null,
    listExternoId: null,
    ferramentaGestaoId: canal === 'ferramenta' ? ferramentaGestaoId : null,
    nomeDestino: '',
    listOptions: [],
    listaSelecionada: {},
    peopleColumnId: null,
    dateColumnId: null,
    textNotasColumnId: null,
    colunasValidas: false,
    issueTypeId: null,
    issueTypeOptions: [],
    issueTypeSelecionado: {},
    configuracaoConfirmada: false
  })

  const handleSelecionarCanal = e => {
    const novoCanal = e?.value?.value || 'email'

    if (novoCanal === 'ferramenta' && !existeIntegracao) {
      dispatch(AddAlert('danger', nls.connectManagementToolMessage))
      return
    }

    onChange(limparEstadoFerramenta(novoCanal))
  }

  const handleChangeUrl = e => {
    const novoValor = e?.value ?? e?.target?.value ?? ''

    onChange({
      ...value,
      urlProjeto: novoValor,
      urlValidada: false,
      projetoExternoId: null,
      listExternoId: null,
      ferramentaGestaoId: novoValor ? ferramentaGestaoId : null,
      nomeDestino: '',
      listOptions: [],
      listaSelecionada: {},
      peopleColumnId: null,
      dateColumnId: null,
      textNotasColumnId: null,
      colunasValidas: false,
      issueTypeId: null,
      issueTypeOptions: [],
      issueTypeSelecionado: {},
      configuracaoConfirmada: false
    })
  }

  const handleBuscar = async () => {
    const result = await onBuscarDestino()

    if (!configuracaoFerramenta || !result) {
      return
    }

    const dadosDestino = extrairDestinoSalvo({
      ferramentaCodigo,
      destinoSalvo: result
    })

    if (!dadosDestino?.urlProjeto && !dadosDestino?.nomeDestino) {
      return
    }

    if (ferramentaCodigo === 'jira') {
      onChange({
        canal: value?.canal || 'ferramenta',
        urlProjeto: dadosDestino.urlProjeto,
        urlValidada: !!dadosDestino.configuracaoConfirmada,
        projetoExternoId: dadosDestino.projetoExternoId,
        listExternoId: dadosDestino.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosDestino.nomeDestino,
        listOptions: dadosDestino.listOptions || [],
        listaSelecionada: dadosDestino.listaSelecionada || {},
        issueTypeId: dadosDestino.issueTypeId || null,
        issueTypeOptions: dadosDestino.issueTypeOptions || [],
        issueTypeSelecionado: dadosDestino.issueTypeSelecionado || {},
        configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
      })
      return
    }

    if (ferramentaCodigo === 'asana') {
      onChange({
        canal: value?.canal || 'ferramenta',
        urlProjeto: dadosDestino.urlProjeto,
        urlValidada: !!dadosDestino.configuracaoConfirmada,
        projetoExternoId: dadosDestino.projetoExternoId,
        listExternoId: dadosDestino.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosDestino.nomeDestino,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
      })
      return
    }

    if (ferramentaCodigo === 'clickup') {
      onChange({
        canal: value?.canal || 'ferramenta',
        urlProjeto: dadosDestino.urlProjeto,
        urlValidada: !!dadosDestino.configuracaoConfirmada,
        projetoExternoId: dadosDestino.projetoExternoId,
        listExternoId: dadosDestino.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosDestino.nomeDestino,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
      })
      return
    }


    if (ferramentaCodigo === 'trello') {
      onChange({
        canal: value?.canal || 'ferramenta',
        urlProjeto: dadosDestino.urlProjeto,
        urlValidada: !!dadosDestino.configuracaoConfirmada,
        projetoExternoId: dadosDestino.projetoExternoId,
        listExternoId: dadosDestino.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosDestino.nomeDestino,
        listOptions: dadosDestino.listOptions || [],
        listaSelecionada: dadosDestino.listaSelecionada || {},
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
      })
      return
    }


    if (ferramentaCodigo === 'monday') {
      onChange({
        canal: value?.canal || 'ferramenta',
        urlProjeto: dadosDestino.urlProjeto,
        urlValidada: !!dadosDestino.configuracaoConfirmada,
        projetoExternoId: dadosDestino.projetoExternoId,
        listExternoId: dadosDestino.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosDestino.nomeDestino,
        listOptions: dadosDestino.listOptions || [],
        listaSelecionada: dadosDestino.listaSelecionada || {},
        peopleColumnId: dadosDestino.peopleColumnId || null,
        dateColumnId: dadosDestino.dateColumnId || null,
        textNotasColumnId: dadosDestino.textNotasColumnId || null,
        colunasValidas: dadosDestino.colunasValidas || false,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
      })
      return
    }



    onChange({
      ...value,
      urlProjeto: dadosDestino.urlProjeto,
      urlValidada: false,
      projetoExternoId: dadosDestino.projetoExternoId,
      listExternoId: dadosDestino.listExternoId,
      ferramentaGestaoId,
      nomeDestino: dadosDestino.nomeDestino,
      issueTypeId: dadosDestino.issueTypeId || null,
      issueTypeOptions: dadosDestino.issueTypeOptions || [],
      issueTypeSelecionado: dadosDestino.issueTypeSelecionado || {},
      configuracaoConfirmada: dadosDestino.configuracaoConfirmada || false
    })

  }

  const handleValidar = async () => {
  if (!urlProjeto) {
    return
  }

  if (ferramentaCodigo === 'jira') {
    onChange({
      ...value,
      urlValidada: false,
      configuracaoConfirmada: false
    })
  }


  if (ferramentaCodigo === 'trello') {
    onChange({
      ...value,
      urlValidada: false,
      listOptions: [],
      listaSelecionada: {},
      listExternoId: null
    })
  }


  if (ferramentaCodigo === 'monday') {
    onChange({
      ...value,
      urlValidada: false,
      configuracaoConfirmada: false
    })
  }



  const result = await onValidarUrl(urlProjeto)

    if (!configuracaoFerramenta || !result) {
      onChange({
        ...value,
        urlValidada: false,
        projetoExternoId: null,
        listExternoId: null,
        ferramentaGestaoId,
        nomeDestino: '',
        listOptions: [],
        listaSelecionada: {},
        peopleColumnId: null,
        dateColumnId: null,
        textNotasColumnId: null,
        colunasValidas: false,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      })
      return
    }


    /******************************************** */
    const dadosValidados = extrairUrlValidada({
      ferramentaCodigo,
      urlValidada: result
    })


    if (ferramentaCodigo === 'monday') {
      const novoEstadoMonday = {
        ...value,
        urlValidada: false,
        projetoExternoId: dadosValidados.projetoExternoId,
        listExternoId: dadosValidados.listExternoId,
        ferramentaGestaoId,
        nomeDestino: dadosValidados.nomeDestino,
        listOptions: dadosValidados.listOptions || [],
        listaSelecionada: dadosValidados.listaSelecionada || {},
        peopleColumnId: dadosValidados.peopleColumnId || null,
        dateColumnId: dadosValidados.dateColumnId || null,
        textNotasColumnId: dadosValidados.textNotasColumnId || null,
        colunasValidas: dadosValidados.colunasValidas || false,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      }

      if (!dadosValidados?.colunasValidas) {
        dispatch(AddAlert('danger', nls.mondayMissingColumnsMessage))
        onChange(novoEstadoMonday)
        return
      }

      dispatch(AddAlert('success', nls.validateUrlSuccessMessage))
      onChange(novoEstadoMonday)
      return
    }


    if (!dadosValidados?.projetoExternoId) {
      onChange({
        ...value,
        urlValidada: false,
        projetoExternoId: null,
        listExternoId: null,
        ferramentaGestaoId,
        nomeDestino: '',
        listOptions: [],
        listaSelecionada: {},
        peopleColumnId: null,
        dateColumnId: null,
        textNotasColumnId: null,
        colunasValidas: false,
        issueTypeId: null,
        issueTypeOptions: [],
        issueTypeSelecionado: {},
        configuracaoConfirmada: false
      })
    }
    /**************************************** */






  }


  const handleSelecionarLista = e => {
    const selecionado = e?.value || {}

    onChange({
      ...value,
      listaSelecionada: selecionado,
      listExternoId: selecionado?.value || null,
      urlValidada: ferramentaCodigo === 'monday' ? false : value?.urlValidada,
      configuracaoConfirmada: ferramentaCodigo === 'monday' ? false : value?.configuracaoConfirmada
    })
  }


  const handleSelecionarIssueType = e => {
    const selecionado = e?.value || {}

    onChange({
      ...value,
      issueTypeSelecionado: selecionado,
      issueTypeId: selecionado?.value || null,
      configuracaoConfirmada: false
    })
  }

  const handleGravar = async () => {
  if (!urlProjeto) {
    return
  }

  await onGravarDestino(
    urlProjeto,
    value?.issueTypeId || null,
    value?.listExternoId || null
  )
}


  const handleConfirmarConfiguracao = async () => {
    if (!urlProjeto) {
      return
    }

    const result = await onGravarDestino(urlProjeto, value?.issueTypeId || null)

    if (!result) {
      return
    }

    onChange({
      ...value,
      configuracaoConfirmada: true
    })
  }


  const handleConfirmarConfiguracaoMonday = async () => {
    if (!urlProjeto || !value?.listExternoId || !value?.colunasValidas) {
      return
    }

    const result = await onGravarDestino(
      urlProjeto,
      null,
      value?.listExternoId || null,
      {
        peopleColumnId: value?.peopleColumnId || null,
        dateColumnId: value?.dateColumnId || null,
        textNotasColumnId: value?.textNotasColumnId || null
      }
    )

    if (!result) {
      return
    }

    onChange({
      ...value,
      urlValidada: true,
      configuracaoConfirmada: true
    })
  }




  return (
    <div className='aprovarplanoplan-canalferramenta'>
      <div className='aprovarplanoplan-canalferramenta__title'>
        {nls.blockChannelToolTitle}
      </div>

      <div className='aprovarplanoplan-canalferramenta__content'>
        <div className='aprovarplanoplan-canalferramenta__subsection'>
          <RadioButton
            name='canalComunicacaoPlano'
            label={nls.channelChoiceLabel}
            options={canalOptions}
            checked={canalOptions.find(item => item.value === canalSelecionado) || canalOptions[0]}
            action={handleSelecionarCanal}
            optionLabel='label'
            optionValue='value'
          />
        </div>

        {canalSelecionado === 'email' && (
          <div className='aprovarplanoplan-canalferramenta__subsection'>
            <div className='aprovarplanoplan-canalferramenta__helper'>
              {nls.emailChannelMessage}
            </div>
          </div>
        )}

        {canalSelecionado === 'ferramenta' && (
          <div className='aprovarplanoplan-canalferramenta__subsection'>
            {!existeIntegracao && !loadingIntegracao && (
              <div className='aprovarplanoplan-canalferramenta__helper aprovarplanoplan-canalferramenta__helper--warning'>
                {nls.noIntegrationMessage}
              </div>
            )}

            {existeIntegracao && (
              <>
                <div className='aprovarplanoplan-canalferramenta__tool-info'>
                  <span className='aprovarplanoplan-canalferramenta__label'>
                    {nls.integratedToolLabel}
                  </span>
                  <strong className='aprovarplanoplan-canalferramenta__value'>
                    {ferramentaNomeExibicao}
                  </strong>
                </div>

                {configuracaoFerramenta?.exibirCampoUrl && (
                  <div className='aprovarplanoplan-canalferramenta__field'>
                    <Input
                      name='urlProjetoFerramenta'
                      action={handleChangeUrl}
                      value={urlProjeto}
                      placeholder={nls.urlPlaceholder}
                    />
                  </div>
                )}

                {ferramentaCodigo === 'monday' ? (
                  <div className='aprovarplanoplan-canalferramenta__helper'>
                    {nls.mondayColumnsHelperText}
                  </div>
                ) : null}

                {configuracaoFerramenta?.exibirNomeDestino && nomeDestinoExibicao ? (
                  <div className='aprovarplanoplan-canalferramenta__project-name'>
                    <span className='aprovarplanoplan-canalferramenta__label'>
                      {nls[configuracaoFerramenta.labelNome]}
                    </span>
                    <strong className='aprovarplanoplan-canalferramenta__value'>
                      {nomeDestinoExibicao}
                    </strong>
                  </div>
                ) : null}


                {(ferramentaCodigo === 'trello' || ferramentaCodigo === 'monday') &&
                configuracaoFerramenta?.exibirListaSelect &&
                Array.isArray(value?.listOptions) &&
                value.listOptions.length > 0 ? (
                  <div className='aprovarplanoplan-canalferramenta__field'>
                    <Select
                      name='trelloLista'
                      label={nls[configuracaoFerramenta.labelLista]}
                      options={value.listOptions}
                      selected={
                        value.listOptions.find(item => item?.value === value?.listExternoId) ||
                        value.listOptions[0]
                      }
                      action={handleSelecionarLista}
                      optionLabel='label'
                      optionValue='value'
                      selectedItem={false}
                    />
                  </div>
                ) : null}


                {ferramentaCodigo === 'jira' &&
                configuracaoFerramenta?.exibirIssueTypeSelect &&
                Array.isArray(value?.issueTypeOptions) &&
                value.issueTypeOptions.length > 0 ? (
                  <div className='aprovarplanoplan-canalferramenta__field'>
                    <Select
                      name='jiraIssueType'
                      label={nls.jiraIssueTypeLabel}
                      options={value.issueTypeOptions}
                      selected={value.issueTypeSelecionado || value.issueTypeOptions[0]}
                      action={handleSelecionarIssueType}
                      optionLabel='label'
                      optionValue='value'
                      selectedItem={false}
                    />
                  </div>
                ) : null}

                {configuracaoFerramenta && (
                  <>
                    <div className='aprovarplanoplan-canalferramenta__actions'>
                      <Button
  data-cy='pdca-plan-integration-validate'
  color='default'
  onClick={handleValidar}
  disabled={!urlProjeto || loadingValidarUrl}
>
                        {nls[configuracaoFerramenta.labelBotaoBuscar]}
                      </Button>

                      <Button
  data-cy='pdca-plan-integration-search'
  color='default'
  onClick={handleBuscar}
  disabled={loadingBuscarDestino}
>
                        {nls[configuracaoFerramenta.labelBotaoBuscarConfiguracao]}
                      </Button>

                      <Button
                      data-cy='pdca-plan-integration-save'
                      data-cy-effect='write'
                        color='default'
                        onClick={
                          ferramentaCodigo === 'jira'
                            ? handleConfirmarConfiguracao
                            : ferramentaCodigo === 'monday'
                              ? handleConfirmarConfiguracaoMonday
                              : handleGravar
                        }
                        disabled={
                          ferramentaCodigo === 'jira'
                            ? (!urlProjeto || !value?.issueTypeId || loadingGravarDestino)
                            : ferramentaCodigo === 'monday'
                              ? (!urlProjeto || !value?.listExternoId || !value?.colunasValidas || loadingGravarDestino)
                              : (!urlProjeto || loadingGravarDestino)
                        }

                      >
                        {nls[configuracaoFerramenta.labelBotaoValidar]}
                      </Button>
                    </div>

                    <div className='aprovarplanoplan-canalferramenta__status'>
                      {(ferramentaCodigo === 'jira' || ferramentaCodigo === 'monday'
                        ? value?.configuracaoConfirmada
                        : value?.urlValidada)
                        ? nls.validUrlMessage
                        : nls.invalidUrlMessage}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}


export default Canalferramenta